
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/new-grad",
      function () {
        return require("private-next-pages/jobs/new-grad/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/new-grad"])
      });
    }
  